__webpack_require__.p = "https://stg-hub.mys-team.com/";